const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const api = {
  // Products
  getProducts: async (category = null) => {
    const url = category ? `${API_URL}/api/products?category=${category}` : `${API_URL}/api/products`;
    const response = await fetch(url);
    return response.json();
  },

  getProduct: async (id) => {
    const response = await fetch(`${API_URL}/api/products/${id}`);
    return response.json();
  },

  // Reels
  getReels: async () => {
    const response = await fetch(`${API_URL}/api/reels`);
    return response.json();
  },

  // Auth
  sendOTP: async (phone) => {
    const response = await fetch(`${API_URL}/api/auth/send-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone }),
    });
    return response.json();
  },

  verifyOTP: async (phone, otp) => {
    const response = await fetch(`${API_URL}/api/auth/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone, otp }),
    });
    return response.json();
  },

  // Orders
  createOrder: async (orderData) => {
    const response = await fetch(`${API_URL}/api/orders/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderData),
    });
    const data = await response.json();
    console.log('Create order response:', data);
    return data;
  },

  getMyOrders: async (phone) => {
    const response = await fetch(`${API_URL}/api/orders/my-orders?phone=${encodeURIComponent(phone)}`);
    return response.json();
  },

  // Admin
  adminCreateProduct: async (productData, token) => {
    const response = await fetch(`${API_URL}/api/admin/products`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(productData),
    });
    return response.json();
  },

  adminUpdateProduct: async (id, productData, token) => {
    const response = await fetch(`${API_URL}/api/admin/products/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(productData),
    });
    return response.json();
  },

  adminDeleteProduct: async (id, token) => {
    const response = await fetch(`${API_URL}/api/admin/products/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminGetCloudflareUploadUrl: async (token) => {
    const response = await fetch(`${API_URL}/api/admin/cloudflare/upload-url`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminAIExtract: async (imageBase64, token) => {
    const response = await fetch(`${API_URL}/api/admin/ai-extract`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ image_base64: imageBase64 }),
    });
    return response.json();
  },

  adminGetOrders: async (token) => {
    const response = await fetch(`${API_URL}/api/admin/orders`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminUpdateOrderStatus: async (orderId, status, token) => {
    const response = await fetch(`${API_URL}/api/admin/orders/${orderId}/status?status=${status}`, {
      method: 'PUT',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminCreateReel: async (reelData, token) => {
    const response = await fetch(`${API_URL}/api/admin/reels`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(reelData),
    });
    return response.json();
  },

  adminDeleteReel: async (reelId, token) => {
    const response = await fetch(`${API_URL}/api/admin/reels/${reelId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminGetStreamUploadUrl: async (token) => {
    const response = await fetch(`${API_URL}/api/admin/cloudflare/stream-upload-url`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  // Coupon APIs
  applyCoupon: async (code, cartTotal, phone) => {
    const response = await fetch(`${API_URL}/api/coupons/apply`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, cart_total: cartTotal, phone }),
    });
    return response.json();
  },

  adminGetCoupons: async (token) => {
    const response = await fetch(`${API_URL}/api/coupons/admin/list`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminCreateCoupon: async (coupon, token) => {
    const response = await fetch(`${API_URL}/api/coupons/admin/create`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify(coupon),
    });
    return response.json();
  },

  adminUpdateCoupon: async (couponId, coupon, token) => {
    const response = await fetch(`${API_URL}/api/coupons/admin/${couponId}`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify(coupon),
    });
    return response.json();
  },

  adminDeleteCoupon: async (couponId, token) => {
    const response = await fetch(`${API_URL}/api/coupons/admin/${couponId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  // Review APIs
  getProductReviews: async (productId, page = 1) => {
    const response = await fetch(`${API_URL}/api/reviews/product/${productId}?page=${page}`);
    return response.json();
  },

  canReview: async (productId, phone) => {
    const response = await fetch(`${API_URL}/api/reviews/can-review?product_id=${productId}&phone=${encodeURIComponent(phone)}`);
    return response.json();
  },

  createReview: async (review) => {
    const response = await fetch(`${API_URL}/api/reviews/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(review),
    });
    return response.json();
  },

  adminGetReviews: async (token, page = 1, status = 'all') => {
    const response = await fetch(`${API_URL}/api/reviews/admin/list?page=${page}&status=${status}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminModerateReview: async (reviewId, isApproved, token) => {
    const response = await fetch(`${API_URL}/api/reviews/admin/${reviewId}/moderate`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify({ is_approved: isApproved }),
    });
    return response.json();
  },

  adminDeleteReview: async (reviewId, token) => {
    const response = await fetch(`${API_URL}/api/reviews/admin/${reviewId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  // Marketing Settings
  adminGetMarketingSettings: async (token) => {
    const response = await fetch(`${API_URL}/api/admin/marketing-settings`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return response.json();
  },

  adminSaveMarketingSettings: async (settings, token) => {
    const response = await fetch(`${API_URL}/api/admin/marketing-settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(settings),
    });
    return response.json();
  },
};

export default api;